import { render, staticRenderFns } from "./Science.vue?vue&type=template&id=6978fae4&scoped=true"
import script from "./Science.vue?vue&type=script&lang=js"
export * from "./Science.vue?vue&type=script&lang=js"
import style0 from "./Science.vue?vue&type=style&index=0&id=6978fae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978fae4",
  null
  
)

export default component.exports